import { useContext, useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import Loading from '../../../Loading/Loading';
import { MovimentacaoContext } from '../context/movimentacao-bancario-context';
import ListMovimentacaoBancario from '../ListMovimentacaoBancaria';
import ReactSelect from '../../../data/reactSelect';
import { InputDefault } from '../../../data/inputDefault';
import { useAppSelector } from '../../../../redux/store';
import * as S from './styled';

export default function MovimentacaoBancario(props: any) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const {
    listBankaccount,
    banckAccountId,
    setBanckaccountId,
    showMovimentacao,
    handleCloseMovimentacao,
    showList,
    pdv,
    setPdv,
    listPdv,
    startDate,
    handleDateStart,
    endDate,
    handleDateEnd,
    fillPdv,
    handleSearchList,
    loading,
    fillBankAccounts,
  } = useContext(MovimentacaoContext);

  const newListBankaccount = listBankaccount?.filter(
    (item: any) => item?.store_id === storeMe?.storeActive?.id
  );

  useEffect(() => {
    fillPdv();
    fillBankAccounts(storeMe?.storeActive?.id);
  }, []);

  return (
    <>
      <Modal
        show={showMovimentacao}
        onHide={handleCloseMovimentacao}
        size={showList ? 'xl' : 'lg'}
      >
        {!showList ? (
          <>
            <Modal.Header closeButton>
              <Modal.Title className="fs-6">Movimentação Bancário</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ fontSize: '12px' }}>
              <S.Wrapper>
                <ReactSelect
                  label="Conta"
                  state={banckAccountId}
                  isClearable={true}
                  placeholder={'Conta'}
                  options={newListBankaccount.map((item: any) => ({
                    value: item.id,
                    label: item.description,
                  }))}
                  setState={setBanckaccountId}
                />

                <ReactSelect
                  label="Considerar Registros do PDV?"
                  state={pdv}
                  isClearable={true}
                  placeholder={'Selecione uma opção'}
                  options={listPdv}
                  setState={setPdv}
                />

                <InputDefault
                  label="De"
                  size="sm"
                  type="date"
                  state={startDate}
                  onChenge={(e) => handleDateStart(e.target.value)}
                />

                <InputDefault
                  label="Até"
                  size="sm"
                  type="date"
                  state={endDate}
                  onChenge={(e) => handleDateEnd(e.target.value)}
                />
              </S.Wrapper>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
              <Button size="sm" onClick={handleCloseMovimentacao}>
                Cancelar
              </Button>
              <Button size="sm" onClick={handleSearchList}>
                Proximo
              </Button>
            </Modal.Footer>
          </>
        ) : (
          <ListMovimentacaoBancario />
        )}
      </Modal>

      {loading && <Loading />}
    </>
  );
}
